// Fetch all posts for the blog listing page
export const ALL_POSTS_QUERY = `*[_type == "post"] | order(publishedAt desc) {
  _id,
  title,
  slug,
  publishedAt,
  excerpt,
  mainImage,
  "author": author->{ name, image },
  "categories": categories[]->{ title, slug }
}`

// Fetch a single post by slug for the detail page
export const POST_BY_SLUG_QUERY = `*[_type == "post" && slug.current == $slug][0] {
  _id,
  title,
  slug,
  publishedAt,
  excerpt,
  mainImage,
  body,
  "author": author->{ name, image, bio },
  "categories": categories[]->{ title, slug }
}`

// Fetch recent posts (for sidebar)
export const RECENT_POSTS_QUERY = `*[_type == "post"] | order(publishedAt desc)[0..4] {
  _id,
  title,
  slug,
  publishedAt,
  mainImage
}`
